import { render, staticRenderFns } from "./VStatusForm.vue?vue&type=template&id=58459cfc&"
import script from "./VStatusForm.vue?vue&type=script&lang=js&"
export * from "./VStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports